import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import BaseAppService from '../../../../application/platform/scp/base/base-app-service';
import { ACTION_TYPES, useIrpSearchDispatch, useIrpSearchState } from './irp-search-context';
import { useBaseLayout } from '../../../../components/context/use-base-layout';
import { IrpSortField } from '../../../../model/scp/irp/irp-sort-field';
import { SortDirection } from '../../../../model/scp/base/sort-direction';

const DEFAULT_SORT_BY = IrpSortField.UpdatedDate;
const DEFAULT_SORT_DIRECTION = SortDirection.Descending;

export const useIrpSearchController = () => {
    const navigate = useNavigate();
    const { showLoading, showMessage } = useBaseLayout();
    const dispatch = useIrpSearchDispatch();
    const state = useIrpSearchState();

    useEffect(() => {
        loadInitialData();
    }, []);

    async function loadInitialData() {
        try {
            showLoading({ open: true });

            const modality = await BaseAppService.listModality();

            dispatch({ type: ACTION_TYPES.setModality, payload: modality });

            showLoading({ open: false });
        } catch (error) {
            showMessage({
                open: true,
                message: 'Não foi possível carregar os filtros de pesquisa',
                detail: (error as any).details || (error as Error).message,
                type: 'error'
            });
            showLoading({ open: false });
        }
    }

    function handleOnChange(e: any) {
        let term = state.parameters.term;
        let modalityId = state.parameters.modalityId;
        let clientId = state.parameters.clientId;
        let year = state.parameters.year;
        let sortBy = state.parameters.sortBy;
        let sortDirection = state.parameters.sortDirection;

        if (e.target.name === "input-term") {
            term = e.target.value;
        }
        if (e.target.name === "select-modality") {
            modalityId = e.target.value;
        }
        if (e.target.name === "select-client") {
            clientId = e.target.value;
        }
        if (e.target.name === "input-year") {
            const parsed = parseInt(e.target.value, 10);
            year = isNaN(parsed) ? undefined : parsed;
        }
        if (e.target.name === "select-sort") {
            if (e.target.value) {
                const [sortByValue, sortDirectionValue] = e.target.value.split('_');
                sortBy = Number(sortByValue);
                sortDirection = Number(sortDirectionValue);
            } else {
                sortBy = DEFAULT_SORT_BY;
                sortDirection = DEFAULT_SORT_DIRECTION;
            }
        }

        dispatch({
            type: ACTION_TYPES.updateParameter,
            payload: {
                ...state.parameters,
                term,
                clientId,
                modalityId,
                year,
                sortBy,
                sortDirection
            }
        });
    }

    function handleSearch() {
        dispatch({
            type: ACTION_TYPES.updateParameter,
            payload: {
                ...state.parameters,
                page: 0
            }
        });
        dispatch({ type: ACTION_TYPES.triggerSearch });
    }

    function handleClearFilters() {
        dispatch({
            type: ACTION_TYPES.updateParameter,
            payload: {
                page: 0,
                pageSize: 100,
                term: undefined,
                clientId: undefined,
                modalityId: undefined,
                year: undefined,
                sortBy: DEFAULT_SORT_BY,
                sortDirection: DEFAULT_SORT_DIRECTION
            }
        });
        dispatch({ type: ACTION_TYPES.triggerSearch });
    }

    function navigateToCreate() {
        navigate('/intencao-registro-preco/publicar');
    }

    return {
        handleOnChange,
        handleSearch,
        handleClearFilters,
        navigateToCreate
    };
}
